import Home from "./home/module";

import Checkout from "./checkout/module";
import Account from "./account/module";
import Search from "./search/module";

import Activities from "./activities/module";
import Activity from "./activity/module";
import Locations from "./locations";
import Location from "./location/module";
import aboutController from "./about";
import contactController from "./contact";
import marketpriceController from "./marketprice";
import faqController from "./faq";

import practicalController from "./practical";
import basketController from "./basket";
import BasketFixed from "./basket-fixed/module";

import authTestController from "./auth-test";
import termsController from "./terms";
import maintenanceController from "./maintenance";

const modul = angular
    .module("pages", [
        Account,
        BasketFixed,
        Checkout,
        Search,
        Activities,
        Activity,
        Locations,
        Location,
        Home,
    ])

    .controller("aboutController", aboutController)
    .controller("contactController", contactController)
    .controller("marketpriceController", marketpriceController)
    .controller("faqController", faqController)
    .controller("practicalController", practicalController)
    .controller("authTestController", authTestController)
    .controller("basketController", basketController)
    .controller("termsController", termsController)
    .controller("maintenanceController", maintenanceController);

export default modul.name;
